module.exports = __webpack_public_path__ + "img/10market3.717efd51.jpg";